import { render, staticRenderFns } from "./CmgMemberRewards.vue?vue&type=template&id=3c3f88d9&lang=pug"
import script from "./cmg-member-rewards.ts?vue&type=script&lang=ts&external"
export * from "./cmg-member-rewards.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports